import { makeStyles } from '@mui/styles'
import { getPixelInREM } from '../../common/material'

export const useMenuStyles = makeStyles((theme) => ({
    menu: {
        paddingTop: getPixelInREM(72),
        paddingLeft: getPixelInREM(10),
        paddingRight: getPixelInREM(10),
        display: 'flex',
        flexDirection: 'column',
        flex: 0,
        [`&.open`]: {
            flex: 1
        }
    },
    toggleBox: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
        paddingBottom: getPixelInREM(15)
    },
    toggleButton: {
        cursor: 'pointer',
        width: getPixelInREM(14),
        marginRight: getPixelInREM(20),
        marginLeft: getPixelInREM(16),
        [`&.open`]: {
            float: 'left',
            transform: ` rotate(180deg)`
        }
    },
    text: {
        cursor: 'pointer',
        fontSize: getPixelInREM(12),
        fontWeight: 600,
        minWidth: getPixelInREM(260)
    }
}))

export const useLoadingStyles = makeStyles(() => ({
    wrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    submenuWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingLeft: getPixelInREM(20)
    },
    menuItem: {
        width: '100%',
        marginTop: getPixelInREM(10),
        [`&.MuiSkeleton-text`]: {
            borderRadius: 25
        }
    },
    submenuItem: {
        width: '100%',
        [`&.MuiSkeleton-text`]: {
            borderRadius: 25
        }
    }
}))
